const headerImageUrl =
  'https://picsum.photos/seed/autorply-flow-header/1200/630';

const carouselImageUrls = [
  'https://picsum.photos/seed/autorply-card-1/1200/630',
  'https://picsum.photos/seed/autorply-card-2/1200/630',
  'https://picsum.photos/seed/autorply-card-3/1200/630',
  'https://picsum.photos/seed/autorply-card-4/1200/630',
  'https://picsum.photos/seed/autorply-card-5/1200/630',
];

const startNode = ({ id, title, triggerKeywords, position }) => ({
  id,
  type: 'start',
  label: title,
  config: {
    title,
    matchType: 'exact',
    webhookUrl: '',
    assignedAgentId: '',
    triggerKeywords,
  },
  message: '',
  summary: triggerKeywords,
  position,
  condition: '',
});

const noMatchNode = ({ id, title, position }) => ({
  id,
  type: 'noMatch',
  label: title,
  config: {
    title,
  },
  message: '',
  summary: title,
  position,
  condition: '',
});

const interactiveHeader = () => ({
  enabled: true,
  type: 'media',
  text: '',
  mediaType: 'image',
  mediaSource: 'link',
  mediaLink: headerImageUrl,
  mediaUrl: headerImageUrl,
  mediaId: '',
  blobId: '',
  blobKey: '',
  contentType: 'image/jpeg',
  fileSize: 0,
  fileName: 'header.jpg',
});

const interactiveNode = ({ id, body, footer = '', position }) => ({
  id,
  type: 'interactive',
  label: 'Interactive',
  config: {
    body,
    footer,
    typingOnDisplay: false,
    delay: {
      seconds: 0,
      minutes: 0,
      hours: 0,
    },
    header: interactiveHeader(),
  },
  message: body,
  summary: body,
  position,
  condition: '',
});

const buttonNode = ({ id, title, position }) => ({
  id,
  type: 'button',
  label: 'Button',
  config: {
    title,
    payload: `button_${id}`,
    nextStepType: 'message',
    linkedFlowId: '',
    addLabelIds: [],
    removeLabelIds: [],
  },
  message: '',
  summary: title,
  position,
  condition: '',
});

const textNode = ({ id, body, position }) => ({
  id,
  type: 'text',
  label: 'Text Message',
  config: {
    header: '',
    body,
    footer: '',
  },
  message: body,
  summary: body,
  position,
  condition: '',
});

const keyboardNode = ({ id, buttonText, position }) => ({
  id,
  type: 'keyboard',
  label: 'Keyboard',
  config: {
    buttonText,
  },
  message: '',
  summary: buttonText,
  position,
  condition: '',
});

const sectionNode = ({ id, title, position }) => ({
  id,
  type: 'section',
  label: 'Section',
  config: {
    title,
  },
  message: '',
  summary: title,
  position,
  condition: '',
});

const rowNode = ({ id, title, description, position }) => ({
  id,
  type: 'row',
  label: 'Row',
  config: {
    title,
    payload: `row_${id}`,
    description,
  },
  message: '',
  summary: title,
  position,
  condition: '',
});

const carouselNode = ({ id, body, cards, position }) => ({
  id,
  type: 'carousel',
  label: 'Interactive Carousel',
  config: {
    body,
    actionType: 'url',
    cards,
  },
  message: body,
  summary: `${body} · ${cards.length} cards · URL`,
  position,
  condition: '',
});

const carouselCard = ({ body, mediaUrl, buttonText, buttonUrl }) => ({
  body,
  mediaType: 'image',
  mediaSource: 'link',
  mediaLink: mediaUrl,
  mediaUrl,
  blobId: '',
  blobKey: '',
  contentType: 'image/jpeg',
  fileSize: 0,
  fileName: '',
  buttonText,
  buttonUrl,
  quickReplies: [],
});

const connection = ({
  id,
  source,
  target,
  sourceOutput,
  targetInput = 'reply',
}) => ({
  id,
  source,
  sourceOutput,
  target,
  targetInput,
});

const welcomeTemplateDefinition = (labels = {}) => ({
  version: 1,
  nodes: [
    noMatchNode({
      id: 'no_match_welcome',
      title: labels.noMatchTitle || 'Welcome Message',
      position: { x: 120, y: 120 },
    }),
    interactiveNode({
      id: 'interactive_welcome',
      body: 'مرحبًا بك في نموذج الرسالة الترحيبية. اختر أحد الخيارات التالية.',
      footer: 'يمكنك تعديل هذه الرسالة قبل النشر',
      position: { x: 470, y: 120 },
    }),
    buttonNode({
      id: 'button_services',
      title: 'الخدمات',
      position: { x: 860, y: 20 },
    }),
    buttonNode({
      id: 'button_prices',
      title: 'الأسعار',
      position: { x: 860, y: 180 },
    }),
    buttonNode({
      id: 'button_support',
      title: 'الدعم',
      position: { x: 860, y: 340 },
    }),
    textNode({
      id: 'text_services',
      body: 'هذه رسالة تعريفية بالخدمات. استبدلها بمحتواك الفعلي.',
      position: { x: 1220, y: 0 },
    }),
    textNode({
      id: 'text_prices',
      body: 'هذه رسالة تعريفية بالأسعار أو الباقات. استبدلها بمحتواك الفعلي.',
      position: { x: 1220, y: 160 },
    }),
    textNode({
      id: 'text_support',
      body: 'هذه رسالة ترشد العميل إلى الدعم أو التحدث مع الفريق.',
      position: { x: 1220, y: 320 },
    }),
  ],
  connections: [
    connection({
      id: 'conn_start_welcome',
      source: 'no_match_welcome',
      sourceOutput: 'next',
      target: 'interactive_welcome',
    }),
    connection({
      id: 'conn_welcome_button_1',
      source: 'interactive_welcome',
      sourceOutput: 'buttons',
      target: 'button_services',
    }),
    connection({
      id: 'conn_welcome_button_2',
      source: 'interactive_welcome',
      sourceOutput: 'buttons',
      target: 'button_prices',
    }),
    connection({
      id: 'conn_welcome_button_3',
      source: 'interactive_welcome',
      sourceOutput: 'buttons',
      target: 'button_support',
    }),
    connection({
      id: 'conn_welcome_text_1',
      source: 'button_services',
      sourceOutput: 'next',
      target: 'text_services',
    }),
    connection({
      id: 'conn_welcome_text_2',
      source: 'button_prices',
      sourceOutput: 'next',
      target: 'text_prices',
    }),
    connection({
      id: 'conn_welcome_text_3',
      source: 'button_support',
      sourceOutput: 'next',
      target: 'text_support',
    }),
  ],
});

const buttonBotTemplateDefinition = () => ({
  version: 1,
  nodes: [
    startNode({
      id: 'start_bot_buttons',
      title: 'شات بوت - 3 أزرار',
      triggerKeywords: 'buttons-demo',
      position: { x: 120, y: 120 },
    }),
    interactiveNode({
      id: 'interactive_bot_buttons',
      body: 'أهلًا بك. هذه قائمة شات بوت تجريبية بثلاثة أزرار شائعة.',
      footer: 'عدّل النصوص حسب نشاطك التجاري',
      position: { x: 470, y: 120 },
    }),
    buttonNode({
      id: 'button_hours',
      title: 'ساعات العمل',
      position: { x: 860, y: 20 },
    }),
    buttonNode({
      id: 'button_branch',
      title: 'الفروع',
      position: { x: 860, y: 180 },
    }),
    buttonNode({
      id: 'button_booking',
      title: 'الحجز',
      position: { x: 860, y: 340 },
    }),
    textNode({
      id: 'text_hours',
      body: 'مثال: ساعات العمل من الأحد إلى الخميس من 9 صباحًا إلى 6 مساءً.',
      position: { x: 1220, y: 0 },
    }),
    textNode({
      id: 'text_branch',
      body: 'مثال: الفرع الرئيسي في وسط المدينة. أضف العنوان الصحيح هنا.',
      position: { x: 1220, y: 160 },
    }),
    textNode({
      id: 'text_booking',
      body: 'مثال: للحجز يرجى إرسال الاسم ورقم الجوال والوقت المناسب.',
      position: { x: 1220, y: 320 },
    }),
  ],
  connections: [
    connection({
      id: 'conn_start_bot_buttons',
      source: 'start_bot_buttons',
      sourceOutput: 'next',
      target: 'interactive_bot_buttons',
    }),
    connection({
      id: 'conn_bot_button_1',
      source: 'interactive_bot_buttons',
      sourceOutput: 'buttons',
      target: 'button_hours',
    }),
    connection({
      id: 'conn_bot_button_2',
      source: 'interactive_bot_buttons',
      sourceOutput: 'buttons',
      target: 'button_branch',
    }),
    connection({
      id: 'conn_bot_button_3',
      source: 'interactive_bot_buttons',
      sourceOutput: 'buttons',
      target: 'button_booking',
    }),
    connection({
      id: 'conn_bot_text_1',
      source: 'button_hours',
      sourceOutput: 'next',
      target: 'text_hours',
    }),
    connection({
      id: 'conn_bot_text_2',
      source: 'button_branch',
      sourceOutput: 'next',
      target: 'text_branch',
    }),
    connection({
      id: 'conn_bot_text_3',
      source: 'button_booking',
      sourceOutput: 'next',
      target: 'text_booking',
    }),
  ],
});

const listBotTemplateDefinition = () => ({
  version: 1,
  nodes: [
    startNode({
      id: 'start_bot_list',
      title: 'شات بوت - 5 صفوف',
      triggerKeywords: 'list-demo',
      position: { x: 120, y: 200 },
    }),
    interactiveNode({
      id: 'interactive_bot_list',
      body: 'هذا نموذج قائمة جاهزة بخمسة صفوف. اختر الخدمة المناسبة.',
      footer: 'يمكنك تعديل جميع الصفوف والمحتوى قبل النشر',
      position: { x: 470, y: 200 },
    }),
    keyboardNode({
      id: 'keyboard_bot_list',
      buttonText: 'عرض القائمة',
      position: { x: 860, y: 200 },
    }),
    sectionNode({
      id: 'section_services',
      title: 'الخدمات الشائعة',
      position: { x: 1210, y: 200 },
    }),
    rowNode({
      id: 'row_service_1',
      title: 'خدمة 1',
      description: 'وصف مختصر للخدمة الأولى',
      position: { x: 1560, y: -80 },
    }),
    rowNode({
      id: 'row_service_2',
      title: 'خدمة 2',
      description: 'وصف مختصر للخدمة الثانية',
      position: { x: 1560, y: 60 },
    }),
    rowNode({
      id: 'row_service_3',
      title: 'خدمة 3',
      description: 'وصف مختصر للخدمة الثالثة',
      position: { x: 1560, y: 200 },
    }),
    rowNode({
      id: 'row_service_4',
      title: 'خدمة 4',
      description: 'وصف مختصر للخدمة الرابعة',
      position: { x: 1560, y: 340 },
    }),
    rowNode({
      id: 'row_service_5',
      title: 'خدمة 5',
      description: 'وصف مختصر للخدمة الخامسة',
      position: { x: 1560, y: 480 },
    }),
    textNode({
      id: 'text_service_1',
      body: 'هذه رسالة شرح للخدمة الأولى. استبدلها بالمحتوى الحقيقي.',
      position: { x: 1910, y: -100 },
    }),
    textNode({
      id: 'text_service_2',
      body: 'هذه رسالة شرح للخدمة الثانية. استبدلها بالمحتوى الحقيقي.',
      position: { x: 1910, y: 40 },
    }),
    textNode({
      id: 'text_service_3',
      body: 'هذه رسالة شرح للخدمة الثالثة. استبدلها بالمحتوى الحقيقي.',
      position: { x: 1910, y: 180 },
    }),
    textNode({
      id: 'text_service_4',
      body: 'هذه رسالة شرح للخدمة الرابعة. استبدلها بالمحتوى الحقيقي.',
      position: { x: 1910, y: 320 },
    }),
    textNode({
      id: 'text_service_5',
      body: 'هذه رسالة شرح للخدمة الخامسة. استبدلها بالمحتوى الحقيقي.',
      position: { x: 1910, y: 460 },
    }),
  ],
  connections: [
    connection({
      id: 'conn_start_bot_list',
      source: 'start_bot_list',
      sourceOutput: 'next',
      target: 'interactive_bot_list',
    }),
    connection({
      id: 'conn_interactive_keyboard',
      source: 'interactive_bot_list',
      sourceOutput: 'list',
      target: 'keyboard_bot_list',
    }),
    connection({
      id: 'conn_keyboard_section',
      source: 'keyboard_bot_list',
      sourceOutput: 'sections',
      target: 'section_services',
    }),
    connection({
      id: 'conn_section_row_1',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_service_1',
    }),
    connection({
      id: 'conn_section_row_2',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_service_2',
    }),
    connection({
      id: 'conn_section_row_3',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_service_3',
    }),
    connection({
      id: 'conn_section_row_4',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_service_4',
    }),
    connection({
      id: 'conn_section_row_5',
      source: 'section_services',
      sourceOutput: 'rows',
      target: 'row_service_5',
    }),
    connection({
      id: 'conn_row_text_1',
      source: 'row_service_1',
      sourceOutput: 'next',
      target: 'text_service_1',
    }),
    connection({
      id: 'conn_row_text_2',
      source: 'row_service_2',
      sourceOutput: 'next',
      target: 'text_service_2',
    }),
    connection({
      id: 'conn_row_text_3',
      source: 'row_service_3',
      sourceOutput: 'next',
      target: 'text_service_3',
    }),
    connection({
      id: 'conn_row_text_4',
      source: 'row_service_4',
      sourceOutput: 'next',
      target: 'text_service_4',
    }),
    connection({
      id: 'conn_row_text_5',
      source: 'row_service_5',
      sourceOutput: 'next',
      target: 'text_service_5',
    }),
  ],
});

const cardsTemplateDefinition = () => ({
  version: 1,
  nodes: [
    startNode({
      id: 'start_cards',
      title: 'رسائل البطاقات',
      triggerKeywords: 'cards-demo',
      position: { x: 120, y: 150 },
    }),
    carouselNode({
      id: 'carousel_products',
      body: 'استعرض مجموعة بطاقات المنتجات أو الخدمات في هذا النموذج الجاهز.',
      position: { x: 470, y: 120 },
      cards: [
        carouselCard({
          body: 'بطاقة المنتج 1 مع وصف تجريبي قصير.',
          mediaUrl: carouselImageUrls[0],
          buttonText: 'عرض المنتج',
          buttonUrl: 'https://app.autorply.online/',
        }),
        carouselCard({
          body: 'بطاقة المنتج 2 مع وصف تجريبي قصير.',
          mediaUrl: carouselImageUrls[1],
          buttonText: 'عرض المنتج',
          buttonUrl: 'https://app.autorply.online/',
        }),
        carouselCard({
          body: 'بطاقة المنتج 3 مع وصف تجريبي قصير.',
          mediaUrl: carouselImageUrls[2],
          buttonText: 'عرض المنتج',
          buttonUrl: 'https://app.autorply.online/',
        }),
        carouselCard({
          body: 'بطاقة المنتج 4 مع وصف تجريبي قصير.',
          mediaUrl: carouselImageUrls[3],
          buttonText: 'عرض المنتج',
          buttonUrl: 'https://app.autorply.online/',
        }),
        carouselCard({
          body: 'بطاقة المنتج 5 مع وصف تجريبي قصير.',
          mediaUrl: carouselImageUrls[4],
          buttonText: 'عرض المنتج',
          buttonUrl: 'https://app.autorply.online/',
        }),
      ],
    }),
  ],
  connections: [
    connection({
      id: 'conn_start_cards',
      source: 'start_cards',
      sourceOutput: 'next',
      target: 'carousel_products',
    }),
  ],
});

const templateBuilders = {
  welcome_buttons: welcomeTemplateDefinition,
  chatbot_buttons: buttonBotTemplateDefinition,
  chatbot_list: listBotTemplateDefinition,
  cards_carousel: cardsTemplateDefinition,
};

export const flowTemplateIds = Object.freeze(Object.keys(templateBuilders));

export const buildConversationFlowTemplate = (templateId, labels = {}) => {
  const builder = templateBuilders[templateId];
  return builder ? builder(labels) : { version: 1, nodes: [], connections: [] };
};
